import type { Locale } from "@/i18n/config";

const LOCALE_STORAGE_KEY = "ta3na.locale.v1";
const LOCALE_COOKIE_NAME = "ta3na.locale";

export function saveLocalePreference(locale: Locale): void {
  window.localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  if (locale === "en") {
    document.cookie = `${LOCALE_COOKIE_NAME}=; Path=/; Max-Age=0; SameSite=Lax; Secure`;
    return;
  }
  document.cookie = `${LOCALE_COOKIE_NAME}=${locale}; Path=/; Max-Age=31536000; SameSite=Lax; Secure`;
}
